import { Theme } from '@material-ui/core';
import { EMOTION_THEME, IEMotionTheme } from './emotionTheme';
import MUI_THEME from './muiTheme';

export type AffilimateTheme = Theme & IEMotionTheme;

export const COMBINED_THEME: AffilimateTheme = {
  ...MUI_THEME,
  ...EMOTION_THEME
};

export { EMOTION_THEME, MUI_THEME };
